/** Nome do produto exibido nas telas de autenticação (eyebrow do formulário e painel de marca). */
export const AUTH_PRODUCT_NAME = "Social Media Manager";
